import React, { createContext, useContext, useState } from "react";

const StaffAuthContext = createContext();

export const StaffAuthProvider = ({ children }) => {
  const [staffToken, setStaffToken] = useState(localStorage.getItem("staffToken"));

  const login = (token) => {
    localStorage.setItem("staffToken", token);
    setStaffToken(token);
  };

  const logout = () => {
    localStorage.removeItem("staffToken");
    setStaffToken(null);
  };

  return (
    <StaffAuthContext.Provider value={{ staffToken, login, logout }}>
      {children}
    </StaffAuthContext.Provider>
  );
};

export const useStaffAuth = () => useContext(StaffAuthContext);